/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import {
  AnalyticsFilterOperator,
  AnalyticsFilterOperator$outboundSchema,
} from "./analyticsfilteroperator.js";

/**
 * A filter on a dimension. All filters are ANDed.
 */
export type AnalyticsFilter = {
  /**
   * Dimension to filter on
   */
  field: string;
  /**
   * equals takes exactly one value; in matches any of them.
   */
  values: Array<string>;
  operator: AnalyticsFilterOperator;
};

/** @internal */
export type AnalyticsFilter$Outbound = {
  field: string;
  values: Array<string>;
  operator: string;
};

/** @internal */
export const AnalyticsFilter$outboundSchema: z.ZodMiniType<
  AnalyticsFilter$Outbound,
  AnalyticsFilter
> = z.object({
  field: z.string(),
  values: z.array(z.string()),
  operator: AnalyticsFilterOperator$outboundSchema,
});

export function analyticsFilterToJSON(
  analyticsFilter: AnalyticsFilter,
): string {
  return JSON.stringify(AnalyticsFilter$outboundSchema.parse(analyticsFilter));
}
